'use client';
import {
  Box,
  Heading,
  SimpleGrid,
  Tag,
  TagLabel,
  TagLeftIcon,
  Text,
} from '@chakra-ui/react';
import slugify from 'react-slugify';

import ButtonCustom from '@/app/_components/button/ButtonCustom';
import CustomImage from '@/app/_components/custom-image/CustomImage';
import LinkCustom from '@/app/_components/link/LinkCustom';
import { ReactComponent as StarTag } from '@/app/_icons/starDark.svg';
import { useFloatingCTA } from '@/hooks/floating-cta.hook';
import { getImageLink } from '@/services/link.service';
import { Range } from '@/types/request/request.types';

import Styles from './AfterSalesPromotionCard.module.scss';

type AfterSalesPromotionCardProps = {
  title: string;
  vehicle_type: string;
  sub_title: string;
  id: number;
  image: string;
  type: string;
  ranges: Range[];
  range?: { name: string; id: number | string };
};

const AfterSalesPromotionCard = ({
  title,
  vehicle_type,
  sub_title = '',
  id,
  image,
  type,
  ranges,
  range,
}: AfterSalesPromotionCardProps) => {
  const { openLeadForm } = useFloatingCTA();

  function getModel(rangeId: number | string): string {
    let model = ranges.findIndex((r) => r.id === rangeId);

    return slugify(ranges[model]?.name);
  }

  return (
    <>
      <Box
        className={Styles.servicePartsCard}
        display={'flex'}
        flexDirection={'column'}
      >
        <Box className={Styles.servicePartsCardImage}>
          <CustomImage
            imageSrc={getImageLink(image || '') ?? ''}
            imageKeys={{
              desktopKey: 'image-400-476',
              mobileKey: 'image-400-476',
            }}
            width={400}
            height={476}
          />
        </Box>
        <Box
          display={'flex'}
          flexDir={'row'}
          alignItems={'center'}
          justifyContent={'end'}
          className={Styles.servicePartsCardHeader}
          gap={2}
          padding={6}
        >
          {vehicle_type === '4' && (
            <Tag
              borderRadius={0}
              variant="solid"
              className={`${Styles.promotionTag} ${Styles.whiteTag}`}
            >
              <TagLeftIcon as={StarTag} width={4} height={4} />

              <TagLabel>New</TagLabel>
            </Tag>
          )}
        </Box>
        <Box
          className={Styles.servicePartsCardFooter}
          padding={{ base: 6 }}
          marginTop={'auto'}
        >
          <Heading
            as="h4"
            className={Styles.titleMd}
            marginBottom={{ base: 4, md: 5 }}
            color={'white'}
          >
            {title}
          </Heading>
          <Box className={Styles.CTAwrapper}>
            <Text className={Styles.titleText} color={'white'}>
              {sub_title}
            </Text>

            <SimpleGrid
              columns={[1, 1, 2, 2]}
              alignItems={'start'}
              spacing={[3]}
              mt={4}
              className={Styles.onHoverCTA}
            >
              <LinkCustom
                className="btnOutlineWhite"
                moduleClass={Styles.btnCTA}
                href={`/promotions/${getModel(range?.id || '')}/${id}`}
              >
                Explore
              </LinkCustom>
              <ButtonCustom
                className="btnOutlineWhite"
                moduleClass={Styles.btnCTA}
                onClick={() => {
                  if (type === 'book-a-service') {
                    openLeadForm('service');
                  } else if (type === 'parts-and-accessories') {
                    openLeadForm('parts');
                  } else {
                    openLeadForm('general');
                  }
                }}
              >
                Get In Touch
              </ButtonCustom>
            </SimpleGrid>
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default AfterSalesPromotionCard;
